module.exports = __webpack_public_path__ + "img/squarespace.6fe13667.png";